import React, { useState } from "react";
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";
import "react-phone-number-input/style.css";
import { Box, LabelStyled } from "../../styled/Elements";
import { useTranslation } from "react-i18next";
import ValidationErrorText from "./ValidationErrorText";
import { PhoneInputWrapper } from "./PhoneInput";

const FloatingPhoneInput = ({
  name,
  label,
  disabled,
  className,
  staric,
  classNameLabel,
  errorDisplay,
  errorMessage = "",
  value,
  onChange,
  ...rest
}) => {
  const { t, i18n } = useTranslation();
  const langDir = i18n.dir();
  const [phoneValue, setPhoneValue] = useState(value || "");
  const [error, setError] = useState("");

  const validatePhoneNumber = (value) => {
    if (!value) {
      setError("");
      return;
    }
    try {
      const phoneNumber = parsePhoneNumber(value);
      if (!isValidPhoneNumber(value, "SA")) {
        setError(t("invalidPhoneNumber"));
        return;
      }
      if (!phoneNumber.isValid()) {
        setError(t("invalidPhoneNumber"));
        return;
      }
      const nationalNumber = phoneNumber.nationalNumber;
      if (nationalNumber.length < 4) {
        setError(t("phoneNumberTooShort"));
        return;
      }
      if (nationalNumber.length > 15) {
        setError(t("phoneNumberTooLong"));
        return;
      }
      setError("");
    } catch (error) {
      setError(t("invalidPhoneNumber"));
    }
  };

  const handlePhoneChange = (newValue) => {
    if (newValue) {
      try {
        const phoneNumber = parsePhoneNumber(newValue);
        if (phoneNumber && phoneNumber.country !== "SA") {
          newValue = `+966${phoneNumber.nationalNumber}`;
        }
      } catch (e) {
        // If parsing fails, just proceed with the value
      }
    }
    setPhoneValue(newValue);
    validatePhoneNumber(newValue);
    if (onChange) onChange({
        target: {
            name,
            value: newValue
        }
    });
  };

  return (
    <PhoneInputWrapper className={className} langDir={langDir} {...rest}>
      <div className="formEleContainer">
        {label && (
          <LabelStyled className={classNameLabel} size="16px" color="var(--darkGrey)">
            {t(label)}
            {staric && <span className="staric">*</span>}
          </LabelStyled>
        )}
        <Box className="position-relative w-100">
          <PhoneInput
            international
            defaultCountry="SA"
            value={phoneValue}
            onChange={handlePhoneChange}
            disabled={disabled}
            flags={flags}
            className="phone-input PhoneInputCountry validated-input px-2 px-sm-3"
            countryCallingCodeEditable={false}
          />
          {error && <ValidationErrorText text={error} extraClass={errorDisplay} />}
        </Box>
      </div>
    </PhoneInputWrapper>
  );
};

export default FloatingPhoneInput;